import * as Sentry from '@sentry/browser';
import {getMetaContent} from 'pf/helper';

Sentry.init({
    dsn: getMetaContent('sentry-dsn'),
    release: getMetaContent('sentry-release'),
    environment: getMetaContent('sentry-environment'),
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    ignoreErrors: [
        'Can\'t find variable: _AutofillCallbackHandler',

        'Unauthorized: Save failed',
        '{"code":401,"message":""}',
        '{"code":403,"message":"Block ist nicht löschbar!"',
        /Fonts (.*) are missing!/,

        'Request failed with status code 401',
        'Avoided redundant navigation to current location',
    ]
});
